import type { WbsClient } from '@bldsoft/cappie/api/wbs'
import type { API, MediaUrl } from '@setplex/tria-api'
import type { AdapterDefaults } from '../../index.h'

import { payload } from '@bldsoft/cappie/rest'
import { EventStatus } from '@setplex/tria-api'
import { DEFAULT_PAGE_SIZE } from '../../constants/generic'
import { formatLiveEvent } from './live-events.format'

export function use(
  client: WbsClient,
  liveEvents: API['liveEvents'],
  _api: API,
  defaults: AdapterDefaults
): void {
  // GET /v3/live-events
  liveEvents.getLiveEventsFx.use(
    async ({
      page,
      count = defaults.count || DEFAULT_PAGE_SIZE,
      sortOrder = defaults.sortOrder || 'asc',
      sortBy = 'startTime',
      ids,
      collectionId,
      title,
      status,
      free,
    }) => {
      const events = await payload(
        client.get.api.v3.liveEvents({
          query: {
            page,
            count,
            status,
            'sort-order': sortOrder,
            'sort-by': sortBy,
            ids,
            collectionId,
            title,
            free,
            'only-recorded': status === EventStatus.ENDED ? true : undefined,
          },
        })
      )

      return {
        ...events,
        content: events.content.map(formatLiveEvent),
      }
    }
  )

  // GET /v3/library/live-events
  liveEvents.getPurchasedLiveEventsFx.use(
    async ({
      page = 0,
      count = defaults.count || 36,
      sortBy,
      sortOrder,
      myList,
    }) => {
      const events = await payload(
        client.get.api.v3.liveEvents({
          query: {
            page,
            count,
            myList,
            'sort-by': sortBy,
            'sort-order': sortOrder,
          },
        })
      )

      return {
        ...events,
        content: events.content.map(formatLiveEvent),
      }
    }
  )

  // GET /v3/live-events/{eventId}
  liveEvents.getLiveEventByIdFx.use(async ({ eventId }) => {
    const event = await payload(client.get.api.v3.liveEvents(eventId)())
    return formatLiveEvent(event)
  })

  // GET /v3/live-events/{eventId}/url
  liveEvents.getLiveEventUrlByIdFx.use(
    async ({ eventId, startTime, rewindType }) => {
      const rewind = startTime != null && rewindType != null

      const media = await payload(
        client.get.api.v3.liveEvents(eventId).url({
          query: {
            startTime: rewind ? startTime : undefined,
            ...(rewind && { [rewindType]: true }),
          },
        })
      )

      return media as MediaUrl
    }
  )
}
